import store from '@/store';

export default function useStore() {
  return store;
}
